import { Box, Divider, Typography, Grid, Button, Chip, Avatar } from "@mui/material";
import { SideBarWidth } from "../../utils/SideBarWidth";
import MembersTree from "../../Components/MembersTree/MembersTree";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleAlert } from "../../utils/handleAlert";
import { WalletsRequests } from "../../api/requests/Wallets/wallets";
import { UserTreeApi } from "../../api/requests/network/network";
import GetValidatedTokenData from "../../utils/helper";
import { Colors } from "../../Theme/Theme";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import PaymentsIcon from "@mui/icons-material/Payments";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import CampaignIcon from "@mui/icons-material/Campaign";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import GroupIcon from "@mui/icons-material/Group";
import { FormOption } from "../../api/requests/FormOptions";
import NewInquiriesBanner from "../FormResponses/NewInquiriesBanner";

export default function DashBoard({ setActiveSideBar }) {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("User");
  const [shortcode, setShortcode] = useState("---");
  const [walletBalance, setWalletBalance] = useState("0");
  const [totalCredit, setTotalCredit] = useState("0");
  const [totalWithdrawal, setTotalWithdrawal] = useState("0");
  const [notifications, setNotifications] = useState([]);
  const [walletHistory, setWalletHistory] = useState([]);
  const [teamSize, setTeamSize] = useState(0);
  const [teamBusiness, setTeamBusiness] = useState(0);

  useEffect(() => {
    const data = GetValidatedTokenData();
    if (data?.userPayload?.name) setUserName(data.userPayload.name);
    if (data?.userPayload?.shortcode) setShortcode(data.userPayload.shortcode);

    const fetchNotifications = async () => {
      try {
        const response = await FormOption.getFormOptions("admin_notifications");
        const items = response?.data || (Array.isArray(response) ? response : []);
        if (items.length > 0) {
          const msgField = items.find((d) => d.form_field === "messages");
          if (msgField?.options?.values?.length > 0) {
            const msgs = msgField.options.values
              .filter((v) => v.label)
              .map((v) => ({ message: v.label }));
            if (msgs.length > 0) setNotifications(msgs);
          }
        }
      } catch (e) {}
    };
    fetchNotifications();

    const getWalletData = async () => {
      try {
        const response = await WalletsRequests.getWalletHistory();
        const txns = response?.data || [];
        setWalletHistory(txns);
        let credit = 0, withdrawal = 0;
        txns.forEach((t) => {
          if (t.type === "CREDIT") credit += parseFloat(t.amount);
          else if (t.type === "WITHDRAWAL") withdrawal += parseFloat(t.amount);
        });
        setTotalCredit(credit.toLocaleString("en-IN"));
        setTotalWithdrawal(withdrawal.toLocaleString("en-IN"));
        setWalletBalance((credit - withdrawal).toLocaleString("en-IN"));
      } catch (error) { handleAlert("Something went wrong", "error"); }
    };

    const getTeamData = async () => {
      try {
        const res = await UserTreeApi.getUserNetwork();
        const nodes = res?.data || (Array.isArray(res) ? res : []);
        const myCode = data?.userPayload?.shortcode || "";

        const findMyNode = (arr, code) => {
          if (!arr || !Array.isArray(arr)) return null;
          for (const n of arr) {
            const nc = n.attributes?.shortcode || n.shortcode || "";
            if (nc === code) return n;
            if (n.children?.length > 0) {
              const found = findMyNode(n.children, code);
              if (found) return found;
            }
          }
          return null;
        };

        let myChildren = [];
        if (myCode) {
          const myNode = findMyNode(nodes, myCode);
          if (myNode?.children?.length > 0) myChildren = myNode.children;
        }
        if (myChildren.length === 0) {
          nodes.forEach((n) => { if (n.children) myChildren = [...myChildren, ...n.children]; });
        }

        let total = 0;
        const countMembers = (arr) => {
          if (!arr || !Array.isArray(arr)) return;
          arr.forEach((n) => { total++; countMembers(n.children); });
        };
        countMembers(myChildren);
        setTeamSize(total);
      } catch (e) {}
    };

    getWalletData();
    getTeamData();
  }, []);

  const calcPeriodBusiness = () => {
    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    const yearStart = new Date(now.getFullYear(), 0, 1);
    let daily = 0, monthly = 0, yearly = 0;
    walletHistory.forEach((t) => {
      if (t.type !== "CREDIT") return;
      const amt = parseFloat(t.amount) || 0;
      const ts = new Date(t.timestamp);
      if (ts >= todayStart) daily += amt;
      if (ts >= monthStart) monthly += amt;
      if (ts >= yearStart) yearly += amt;
    });
    return { daily, monthly, yearly };
  };

  const period = calcPeriodBusiness();
  const marqueeText = notifications.map((n) => n.message).join("   •   ");

  const quickActions = [
    { icon: <HealthAndSafetyIcon />, label: "Insurance", desc: "Health & Life plans", color: Colors.insuranceGreen, bg: Colors.greenSoft, path: "/insurance-policy" },
    { icon: <LocalHospitalIcon />, label: "HospiCash", desc: "Hospital cash benefit", color: Colors.insuranceGreen, bg: Colors.greenSoft, path: "/hospi-cash" },
    { icon: <RequestQuoteIcon />, label: "Loans", desc: "Apply for loans", color: "#F59E0B", bg: "#FFFBEB", path: "/loans" },
    { icon: <AccountBalanceWalletIcon />, label: "Wallet", desc: "Manage wallet", color: "#8B5CF6", bg: "#F5F3FF", path: "/wallet" },
    { icon: <PaymentsIcon />, label: "Transactions", desc: "View all payments", color: Colors.primary, bg: Colors.blueSoft, path: "/transactions" },
    { icon: <ReceiptLongIcon />, label: "Withdraw", desc: "Request payout", color: Colors.primary, bg: Colors.blueSoft, path: "/withdrawal" },
  ];

  const statCards = [
    { label: "Wallet Balance", value: `Rs. ${walletBalance}`, icon: <AccountBalanceWalletIcon sx={{ fontSize: 20 }} />, color: Colors.primary, bg: Colors.blueSoft },
    { label: "Total Credit", value: `Rs. ${totalCredit}`, icon: <ArrowUpwardIcon sx={{ fontSize: 20 }} />, color: Colors.insuranceGreen, bg: Colors.greenSoft },
    { label: "Total Withdrawal", value: `Rs. ${totalWithdrawal}`, icon: <AccountBalanceIcon sx={{ fontSize: 20 }} />, color: "#EF4444", bg: "#FEF2F2" },
    { label: "Shortcode", value: shortcode, icon: <PersonIcon sx={{ fontSize: 20 }} />, color: "#8B5CF6", bg: "#F5F3FF" },
  ];

  const maxBar = Math.max(period.daily, period.monthly, period.yearly, 1);

  return (
    <Box
      marginLeft={{ md: `${SideBarWidth}px` }}
      onClick={() => setActiveSideBar && setActiveSideBar(false)}
      sx={{ width: { xs: "100%", md: `calc(100% - ${SideBarWidth}px)` }, minHeight: "100vh", backgroundColor: Colors.bgColor }}
    >
      {/* Scrolling Notification Banner */}
      {notifications.length > 0 && (
        <Box sx={{
          backgroundColor: Colors.primary, overflow: "hidden",
          py: 0.8, display: "flex", alignItems: "center",
        }}>
          <Box sx={{ px: 1.5, display: "flex", alignItems: "center", flexShrink: 0 }}>
            <CampaignIcon sx={{ fontSize: 16, color: Colors.white }} />
          </Box>
          <Box sx={{ overflow: "hidden", flex: 1 }}>
            <Box
              sx={{
                display: "inline-block", whiteSpace: "nowrap",
                animation: "scrollNotif 10s linear infinite",
                "@keyframes scrollNotif": {
                  "0%": { transform: "translateX(100%)" },
                  "100%": { transform: "translateX(-100%)" },
                },
              }}
            >
              <Typography component="span" sx={{ fontSize: "12px", fontWeight: 400, color: Colors.white, letterSpacing: "0.3px" }}>
                {marqueeText}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}

      <Box sx={{ px: { xs: 2, md: 3 }, py: 3, maxWidth: 1200 }}>
        {localStorage.getItem("Role") === "ADMIN" && <NewInquiriesBanner />}
        <Box sx={{ mb: 3, display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>
          <Box>
            <Typography sx={{ fontWeight: 500, color: Colors.primaryTextColor, fontSize: { xs: "20px", md: "26px" }, letterSpacing: "-0.03em", mb: 0.5, lineHeight: 1.2 }}>
              Welcome back, {userName}
            </Typography>
            <Typography sx={{ color: Colors.secondaryColor, fontSize: "14px", fontWeight: 400, lineHeight: 1.5 }}>
              Here's an overview of your account activity and quick actions.
            </Typography>
          </Box>
          <Button
            variant="outlined" size="small" startIcon={<PersonIcon sx={{ fontSize: 16 }} />}
            onClick={() => navigate("/profile")}
            sx={{
              borderColor: Colors.dividerColor, color: Colors.secondaryColor, fontWeight: 500,
              fontSize: "12px", borderRadius: "8px", px: 2, textTransform: "none",
              "&:hover": { borderColor: Colors.primary, color: Colors.primary, backgroundColor: Colors.blueSoft },
            }}
          >
            KYC & Profile
          </Button>
        </Box>

        {/* Stat Cards */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {statCards.map((card, i) => (
            <Grid item xs={6} sm={6} md={3} key={i}>
              <Box sx={{
                p: 2.5, borderRadius: "12px", backgroundColor: Colors.white,
                border: `1px solid ${Colors.dividerColor}`,
                transition: "all 0.2s",
                "&:hover": { boxShadow: "0 4px 20px rgba(0,0,0,0.05)", borderColor: `${card.color}40` },
              }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                  <Typography sx={{ fontSize: "11px", fontWeight: 500, color: Colors.secondaryColor, textTransform: "uppercase", letterSpacing: "0.6px" }}>
                    {card.label}
                  </Typography>
                  <Avatar sx={{ width: 36, height: 36, backgroundColor: card.bg, color: card.color }}>
                    {card.icon}
                  </Avatar>
                </Box>
                <Typography sx={{ fontWeight: 400, fontSize: { xs: "18px", md: "24px" }, color: Colors.primaryTextColor, lineHeight: 1.2, letterSpacing: "-0.02em" }}>
                  {card.value}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Business Breakdown + Team Stats */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={8}>
            <Box sx={{
              backgroundColor: Colors.white, borderRadius: "12px",
              border: `1px solid ${Colors.dividerColor}`, p: 2.5, height: "100%",
            }}>
              <Typography sx={{ fontSize: "13px", fontWeight: 500, color: Colors.secondaryColor, textTransform: "uppercase", letterSpacing: "0.5px", mb: 2 }}>
                Your Business
              </Typography>
              <Grid container spacing={2} sx={{ mb: 2 }}>
                {[
                  { label: "Today", value: period.daily, color: "#059669" },
                  { label: "This Month", value: period.monthly, color: "#2563EB" },
                  { label: "This Year", value: period.yearly, color: "#8B5CF6" },
                ].map((item, i) => (
                  <Grid item xs={4} key={i}>
                    <Box sx={{ textAlign: "center", py: 1.5, backgroundColor: "#FAFBFF", borderRadius: "10px", border: `1px solid ${Colors.dividerColor}` }}>
                      <Typography sx={{ fontSize: "10px", fontWeight: 400, color: Colors.secondaryColor, textTransform: "uppercase", letterSpacing: "0.5px", mb: 0.5 }}>
                        {item.label}
                      </Typography>
                      <Typography sx={{ fontSize: "18px", fontWeight: 400, color: "#059669" }}>
                        Rs. {item.value.toLocaleString("en-IN")}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                {[
                  { label: "Today", value: period.daily, color: "#059669" },
                  { label: "This Month", value: period.monthly, color: "#2563EB" },
                  { label: "This Year", value: period.yearly, color: "#8B5CF6" },
                ].map((bar, i) => (
                  <Box key={i} sx={{ flex: "1 1 120px" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.3 }}>
                      <Typography sx={{ fontSize: "11px", fontWeight: 400, color: Colors.secondaryColor }}>{bar.label}</Typography>
                    </Box>
                    <Box sx={{ height: 6, backgroundColor: "#F1F5F9", borderRadius: "3px", overflow: "hidden" }}>
                      <Box sx={{
                        height: "100%", borderRadius: "3px",
                        backgroundColor: bar.color,
                        width: `${maxBar > 0 ? (bar.value / maxBar) * 100 : 0}%`,
                        transition: "width 0.6s ease",
                      }} />
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{
              backgroundColor: Colors.white, borderRadius: "12px",
              border: `1px solid ${Colors.dividerColor}`, p: 2.5, height: "100%",
              display: "flex", flexDirection: "column", justifyContent: "center",
            }}>
              <Typography sx={{ fontSize: "13px", fontWeight: 500, color: Colors.secondaryColor, textTransform: "uppercase", letterSpacing: "0.5px", mb: 2 }}>
                Team Overview
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                <Avatar sx={{ width: 44, height: 44, backgroundColor: Colors.blueSoft, color: Colors.primary }}>
                  <GroupIcon sx={{ fontSize: 22 }} />
                </Avatar>
                <Box>
                  <Typography sx={{ fontSize: "10px", fontWeight: 400, color: Colors.secondaryColor, textTransform: "uppercase" }}>
                    Team Members
                  </Typography>
                  <Typography sx={{ fontSize: "22px", fontWeight: 400, color: "#059669" }}>
                    {teamSize}
                  </Typography>
                </Box>
              </Box>
              <Button
                fullWidth size="small"
                endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
                onClick={() => navigate("/total-teams")}
                sx={{
                  color: Colors.primary, fontWeight: 500, fontSize: "13px",
                  textTransform: "none", borderRadius: "8px", py: 1,
                  backgroundColor: Colors.blueSoft,
                  "&:hover": { backgroundColor: Colors.blueMid },
                }}
              >
                View Team Details
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Promo cards */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <Box sx={{
              p: 3, borderRadius: "12px", backgroundColor: Colors.white,
              border: `1px solid ${Colors.greenBorder}`,
              display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2,
              background: `linear-gradient(135deg, ${Colors.greenSoft} 0%, #FFFFFF 100%)`,
              transition: "all 0.2s",
              "&:hover": { boxShadow: "0 4px 20px rgba(5,150,105,0.08)" },
            }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Avatar sx={{ width: 48, height: 48, backgroundColor: Colors.insuranceGreen }}>
                  <HealthAndSafetyIcon sx={{ fontSize: 24, color: "#FFFFFF" }} />
                </Avatar>
                <Box>
                  <Typography sx={{ fontWeight: 500, fontSize: "16px", color: Colors.primaryTextColor }}>Insurance Solutions</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 400, color: Colors.secondaryColor, mt: 0.3 }}>Health & life insurance plans</Typography>
                </Box>
              </Box>
              <Button
                size="small" endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
                onClick={() => navigate("/insurance-policy")}
                sx={{ color: Colors.insuranceGreen, fontWeight: 500, fontSize: "13px", whiteSpace: "nowrap", textTransform: "none", "&:hover": { backgroundColor: Colors.greenSoft } }}
              >
                Explore
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{
              p: 3, borderRadius: "12px", backgroundColor: Colors.white,
              border: "1px solid #FDE68A",
              display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2,
              background: "linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)",
              transition: "all 0.2s",
              "&:hover": { boxShadow: "0 4px 20px rgba(245,158,11,0.08)" },
            }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Avatar sx={{ width: 48, height: 48, backgroundColor: "#F59E0B" }}>
                  <RequestQuoteIcon sx={{ fontSize: 24, color: "#FFFFFF" }} />
                </Avatar>
                <Box>
                  <Typography sx={{ fontWeight: 500, fontSize: "16px", color: Colors.primaryTextColor }}>Apply for Loans</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 400, color: Colors.secondaryColor, mt: 0.3 }}>Personal, Business & Home Loans</Typography>
                </Box>
              </Box>
              <Button
                size="small" endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
                onClick={() => navigate("/loans")}
                sx={{ color: "#F59E0B", fontWeight: 500, fontSize: "13px", whiteSpace: "nowrap", textTransform: "none", "&:hover": { backgroundColor: "#FFFBEB" } }}
              >
                Apply Now
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Quick Actions */}
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontWeight: 500, color: Colors.primaryTextColor, fontSize: "16px", mb: 2, letterSpacing: "-0.01em" }}>
            Quick Actions
          </Typography>
          <Grid container spacing={2}>
            {quickActions.map((action, i) => (
              <Grid item xs={6} sm={4} md={2} key={i}>
                <Box
                  onClick={() => navigate(action.path)}
                  sx={{
                    p: 2.5, borderRadius: "12px", backgroundColor: Colors.white,
                    border: `1px solid ${Colors.dividerColor}`, textAlign: "center",
                    cursor: "pointer", transition: "all 0.2s",
                    "&:hover": {
                      borderColor: action.color, boxShadow: `0 4px 16px ${action.color}15`,
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  <Avatar sx={{ width: 44, height: 44, mx: "auto", mb: 1.5, backgroundColor: action.bg, color: action.color, fontSize: 22 }}>
                    {action.icon}
                  </Avatar>
                  <Typography sx={{ fontWeight: 500, fontSize: "13px", color: Colors.primaryTextColor, mb: 0.5 }}>
                    {action.label}
                  </Typography>
                  <Typography sx={{ fontSize: "11px", fontWeight: 400, color: Colors.secondaryColor, lineHeight: 1.3 }}>
                    {action.desc}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Network Tree */}
        <Box sx={{
          backgroundColor: Colors.white, borderRadius: "12px",
          border: `1px solid ${Colors.dividerColor}`, overflow: "hidden",
        }}>
          <Box sx={{ px: 3, py: 2.5, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              <Typography sx={{ fontWeight: 500, color: Colors.primaryTextColor, fontSize: "16px", letterSpacing: "-0.01em" }}>
                Network Tree
              </Typography>
              <Typography sx={{ fontSize: "13px", fontWeight: 400, color: Colors.secondaryColor, mt: 0.3 }}>
                Your referral network hierarchy
              </Typography>
            </Box>
            <Chip
              label="Live"
              size="small"
              sx={{
                height: 22, fontSize: "10px", fontWeight: 500,
                backgroundColor: Colors.greenSoft, color: Colors.insuranceGreen,
                "& .MuiChip-label": { px: 1 },
              }}
            />
          </Box>
          <Divider sx={{ borderColor: Colors.dividerColor }} />
          <Box sx={{ p: 2, minHeight: 500 }}>
            <MembersTree />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
